import Grandia1 from "./grandiaimage.png";
import Grandia2 from "./grandiaimage.png";

const grandia = [Grandia1, Grandia2];
export default grandia;
